export default __webpack_public_path__ + "static/media/mr-lam.61484a7c.png";